var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2370_30437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9833 3.3335C10.7833 3.3335 3.33331 10.8002 3.33331 20.0002C3.33331 29.2002 10.7833 36.6668 19.9833 36.6668C29.2 36.6668 36.6666 29.2002 36.6666 20.0002C36.6666 10.8002 29.2 3.3335 19.9833 3.3335ZM21.6666 21.6668V11.6668H18.3333V21.6668H21.6666ZM21.6666 28.3335V25.0002H18.3333V28.3335H21.6666ZM6.66665 20.0002C6.66665 27.3668 12.6333 33.3335 20 33.3335C27.3666 33.3335 33.3333 27.3668 33.3333 20.0002C33.3333 12.6335 27.3666 6.66683 20 6.66683C12.6333 6.66683 6.66665 12.6335 6.66665 20.0002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2370_30437)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#54585A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.3ec13c2bcb4ee0c46a1649d7510ab5e4.svg";
export { ForwardRef as ReactComponent };